import {checkIfLinkShouldNotBeMasked} from '../../../../../../helper';

/**
 * @param {string} swatchID - Swatch ID
 * @param {string} title - Swatch title
 * @returns {string} Refinement attributes HTML
 */
const getRefinementAttributesHTML = (swatchID, title) => `id="${swatchID}-desktop" class="value-link" title="${title}"`;

/**
 * @param {string} swatchImageURL - Swatch image URL
 * @param {import('../../../../../type-definitions').Refinement} option - Refinement option
 * @returns {string} Refinement HTML
 */
const getRefinementHTML = (
    swatchImageURL,
    option
) => `<span class="color-bubble color-bubble--background-hidden" style="background-image: url(${swatchImageURL});" aria-hidden="true"
        aria-label="${option.name}">
        <!-- empty -->
    </span>
    <span class="color-name">${option.name}</span>`;

/**
 * @param {import('../../../../../type-definitions').Refinement} option - Refinement option
 * @param {string} swatchID - Swatch ID
 * @param {string} url - Url
 * @param {string} swatchImageURL - Swatch image URL
 * @param {string} title - Swatch title
 * @returns {string} Refinement HTML
 */
const getMaskedRefinement = (option, swatchID, url, swatchImageURL, title) => {
    return `
        <span role="link" tabindex="0" data-href="${url}" rel="nofollow" ${getRefinementAttributesHTML(
        swatchID,
        title
    )}>
            ${getRefinementHTML(swatchImageURL, option)}
        </span>
    `;
};

/**
 * @param {import('../../../../../type-definitions').Refinement} option - Refinement option
 * @param {string} swatchID - Swatch ID
 * @param {string} url - Url
 * @param {string} swatchImageURL - Swatch image URL
 * @param {string} title - Swatch title
 * @returns {string} Refinement HTML
 */
const getUnmaskedRefinement = (option, swatchID, url, swatchImageURL, title) => {
    return `
        <a href="${url}" ${getRefinementAttributesHTML(swatchID, title)}>
            ${getRefinementHTML(swatchImageURL, option)}
        </a>
    `;
};

/**
 * @param {import('../../../../../../type-definitions').Refinement} refinement - refinement
 * @param {import('../../../../../../type-definitions').RefinementOption} option - refinement option
 * @param {import('../../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} color refinement option HTML
 */
export default (refinement, option, refinementURLBuilder, seoUrlConfig) => {
    const swatchID = `swatch-${option.strippedValue}`;
    const swatchImageURL = window.Urls.COLOR_SWATCH_IMAGE.replace('{colorCode}', option.strippedValue);
    let title = window.Resources.SEARCH_REFINEMENT_LABEL.replace('{0}', refinement.name).replace('{1}', option.name);
    if (option.selected) {
        title = window.Resources.SEARCH_REFINEMENT_SELECTED_LABEL.replace('{0}', refinement.name).replace(
            '{1}',
            option.name
        );
    }
    const url = option.selected
        ? refinementURLBuilder.getRefinementValueRemoveURL(refinement.id, option.value)
        : refinementURLBuilder.getRefinementValueURL(refinement.id, option.value);
    return `
        <li class="${option.selected ? 'selected' : ''} ${swatchID}"
            aria-checked="${option.selected ? 'true' : 'false'}"
            data-refinement-id="${refinement.id}"
            data-refinement-info="${option.name}"
            data-refinement-value="${encodeURIComponent(option.value)}"
            data-is-selected="${option.selected ? 'true' : 'false'}"
            role="radio">
            ${
                checkIfLinkShouldNotBeMasked(seoUrlConfig, {
                    name: refinement.id,
                    value: option.value
                })
                    ? getUnmaskedRefinement(option, swatchID, url, swatchImageURL, title)
                    : getMaskedRefinement(option, swatchID, url, swatchImageURL, title)
            }
        </li>
    `;
};
